var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42385 1.51988C1.68903 1.20167 2.16195 1.15868 2.48016 1.42385L14.4802 11.4239C14.6512 11.5663 14.75 11.7774 14.75 12C14.75 12.2226 14.6512 12.4337 14.4802 12.5762L2.48016 22.5762C2.16195 22.8414 1.68903 22.7984 1.42385 22.4802C1.15868 22.1619 1.20167 21.689 1.51988 21.4239L12.8285 12L1.51988 2.57618C1.20167 2.31101 1.15868 1.83809 1.42385 1.51988Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22C11.25 21.5858 11.5858 21.25 12 21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H12C11.5858 22.75 11.25 22.4142 11.25 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.81a3619917b6516f39e7fdffd7dca2fc.svg";
export { ForwardRef as ReactComponent };